import ToolBar from './ToolBar.vue'

const ToolBarComponent = {
  install(Vue, options) {
    Vue.component('tool-bar', ToolBar)
  }
}

export default ToolBarComponent



// WEBPACK FOOTER //
// ./src/components/toolbar/ToolBar.js